import { useEffect } from 'react';
import { setupCrossTabStorageSync } from '@/common/helper/storageCleanup';

/**
 * Hook to synchronize complete storage resets across browser tabs.
 * When any tab resets storage/logs out, this hook ensures the current tab
 * also wipes all tab-specific and shared storage (including sessionStorage child tokens),
 * resets Redux state, and routes to '/login'.
 */
const useCrossTabStorageSync = (): void => {
  useEffect(() => {
    const cleanup = setupCrossTabStorageSync();
    return () => {
      cleanup();
    };
  }, []);
};

export default useCrossTabStorageSync;
